import { FieldValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { prestigeTypeList } from '@/module/Publisher';

import { EnumSelectControl, EnumSelectControlProps } from '@/core/components';

export type PrestigeSelectControlProps<T extends FieldValues> = Omit<EnumSelectControlProps<T>, 'options'>;

export function PrestigeSelectControl<T extends FieldValues>(props: PrestigeSelectControlProps<T>) {
  const { t } = useTranslation();
  const prestigeOptions = prestigeTypeList.map(c => ({ value: c, label: t(`publishers.prestigeEnum.${c}`) }));
  return (
    <EnumSelectControl
      {...props}
      options={prestigeOptions}
    />
  );
}
